import React, { Component, Fragment } from 'react';
import { Stack } from 'office-ui-fabric-react';
import Message from './Message'

/*
**************************************************************************************************************
PROPS :
    ATTRIBUTS :
        bool        estVisible                          indique si liste des messages affich�es � l'�cran
        string      adminMode                           indique si messages consult�s par un admin
        object[]    messages                            tableaux de messages
    METHODES :
        -           -                                   -
**************************************************************************************************************
*/

class MessageList extends Component {

    _styles = {
        stack: {
            root: {
                padding: "10px 0px",
            }
        }
    };

    constructor(props) {
        super(props);
        this.wrapperRef = React.createRef();
    }

    _scrollToBottom = () => {
        this.wrapperRef.current && this.wrapperRef.current.scrollIntoView({ block: "end" });
    };

    componentDidMount = () => {
        this._scrollToBottom();
    };

    componentDidUpdate = () => {
        this._scrollToBottom();
    };

    render = () => {
        return <div ref={this.wrapperRef}>
            <Stack tokens={{ childrenGap: 5 }} styles={this._styles.stack}>
                {this.props.messages.map((message, index) => {
                    return <Fragment key={index}>
                        <Message
                            adminMode={this.props.adminMode}
                            message={message}
                            onSelectionMessage={this.props.onSelectionMessage(message)}
                        />
                    </Fragment>
                })}
            </Stack>
        </div>
    };

}

export default MessageList;